import { render, staticRenderFns } from "./PrimaCardRow.vue?vue&type=template&id=70a65910&"
import script from "./PrimaCardRow.vue?vue&type=script&lang=js&"
export * from "./PrimaCardRow.vue?vue&type=script&lang=js&"
import style0 from "./PrimaCardRow.vue?vue&type=style&index=0&id=70a65910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports